module.exports = __webpack_public_path__ + "34f4d24e1921a8ed1661869ea5f8acc3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/boombox.png
// module id = 1993
// module chunks = 0